import { render, staticRenderFns } from "./SuggestedStockOrder.vue?vue&type=template&id=cfbc2a54"
import script from "./SuggestedStockOrder.vue?vue&type=script&lang=js"
export * from "./SuggestedStockOrder.vue?vue&type=script&lang=js"
import style0 from "./SuggestedStockOrder.vue?vue&type=style&index=0&id=cfbc2a54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports